import { useEffect } from "react";

export const trackPageView = (title, path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: title,
      page_path: path,
    });
  }
};

export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title;
     // Delay page view tracking slightly to ensure title is updated
    const timeout = setTimeout(() => {
      trackPageView(title, window.location.pathname);
    }, 50);

    return () => clearTimeout(timeout);
  }, [title]);
};